import { BrowserRouter, Route, Routes } from "react-router-dom";
import App from "../App";
import HomePage from "../Modules/Home";
import About from "../Modules/About";
import Contact from "../Modules/Contact";
import Menu from "../Modules/Menu";
import SearchPage from "../Modules/SearchPage";
import Promotion from "../Modules/Promotion";
import Video from "../Modules/Video";

const AppRoute = () => {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<App />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<About />} />
            <Route path="/menu" element={<Menu />} />
            <Route path="/gallery" element={<Promotion />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/video" element={<Video />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
};
export default AppRoute;
